import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AddTag, EditTag, Tag, TagParams } from '@app/interfaces/rm/tag';
import { environment } from '@env/environment';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class TagService {
    private baseUrl = environment.api.services.rm + '/label';

    constructor(private http: HttpClient) {}

    async find(params: TagParams): Promise<Tag[]> {
        return lastValueFrom(this.http.get<Tag[]>(`${this.baseUrl}`, {
            params: Object.assign(params),
        }))
    }

    async edit(data: EditTag): Promise<Tag> {
        return lastValueFrom(this.http.put<Tag>(`${this.baseUrl}`, data));
    }

    async add(data: AddTag): Promise<AddTag> {
        return lastValueFrom(this.http.post<Tag>(`${this.baseUrl}`, data));
    }

    async remove(id: number): Promise<void> {
        return lastValueFrom(this.http.delete<void>(`${this.baseUrl}`, {
            params: Object.assign({ id }),
        }));
    }

    formatTagLabel(ids: string | undefined, tags: Tag[]): string {
        console.log('ids', ids, tags);
        const tagIds = ids ? ids.split(',') : [];
        if (tagIds && tagIds.length > 0) {
            return tagIds
                .map((item) => {
                    const currentTag = tags.filter((tag) => tag.id.toString() === item)[0];
                    return currentTag ? currentTag.name : '';
                })
                .filter((item) => item !== '')
                .join(', ');
        }
        return '';
    }
}
